module.exports = __webpack_public_path__ + "static/logo-v15-v2-5f1c1c2b7a1001ad537713467a619b5d.png";